import React, { useState, useLayoutEffect } from "react";

export const useCoverPreviewSize = () => {
    const [coverPreviewSize, setCoverPreviewSize] = useState([0, 0, ''])
    const updateResumeSize = () => {
        const resumeDiv = document.getElementById('preview-resume');
        if (resumeDiv != null) {
            const scale = getScale(resumeDiv.clientWidth, resumeDiv.clientHeight);
            setCoverPreviewSize([resumeDiv.clientWidth, resumeDiv.clientHeight, scale])
        }
    }

    const getScale = (w, h) => {
        return w / 640;
    }

    useLayoutEffect(() => {
        window.addEventListener('resize', updateResumeSize);
        updateResumeSize();
        return () => window.removeEventListener('resize', updateResumeSize);
    }, [])
    return [coverPreviewSize[0], coverPreviewSize[1], coverPreviewSize[2]]
}